import ApiService from './ApiService';

export default new ApiService();
